import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cross\">\r\n<rect x=\"29.6986\" y=\"1.41418\" width=\"40\" height=\"2\" transform=\"rotate(135 29.6986 1.41418)\" fill=\"currentColor\" />\r\n<rect x=\"28.2843\" y=\"29.6985\" width=\"40\" height=\"2\" transform=\"rotate(-135 28.2843 29.6985)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol